<template>
    <section
        v-if="fetchCurrentGradeSubject && fetchCategories"
        class="hero is-flex main"
      >
      <b-loading v-model="isLoading" :is-full-page="true"></b-loading>
        <div class="title is-capitalized">
          {{ fetchCurrentGradeSubject.subject.name }} -
          {{ fetchCurrentGradeSubject.grade.name }}
        </div>
        <div class="card is-relative">
          <div class="img1 icon">
            <img src="@/assets/images/elephant.png" alt="" />
          </div>
          <div class="img2 icon">
            <img src="@/assets/images/book2.png" alt="" />
          </div>
          <div class="img3 icon">
            <img src="@/assets/images/butterfly2.png" alt="" />
          </div>
          <div class="img4 icon">
            <img src="@/assets/images/ball.png" alt="" />
          </div>
          <div class="img5 icon">
            <img src="@/assets/images/stars.png" alt="" />
          </div>
          <div class="card-content">
            <div class="columns">
              <div
                v-for="(category_col_data, i) in categoriesData"
                :key="`COL_${i}`"
              >
                <div
                  v-for="(category, cat_i) in category_col_data"
                  :key="category._id"
                >
                  <div class="column">
                    <div class="box" :style="is_locked[category._id] ? 'background-color: rgb(210 210 210);cursor:not-allowed' : null">
                      
                      <span class="number">{{
                        i * category_col_data.length + cat_i + 1
                      }}</span>
                      <div
                        class="sub-title" 
                        :style="is_locked[category._id] ? 'cursor:not-allowed' : null"
                        @click="goToSkillsOrSubcategories(category)"
                      >
                        {{ category.name }}
                        <span
                          v-if="category.is_not_allowed"
                          style="font-size: 12px; color: rgb(161 161 161)"
                        >(Coming Soon..)
                        </span>
                      </div>
                      <label class="switch" v-if="(getUserType=='ST' || getUserType=='SA')">
                        <input type="checkbox" v-model="is_locked[category._id]" @change="handleLockUnlock(category._id)">
                        <span class="slider round"></span>
                      </label>
                      <span class="progress">0%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  </template>
    <script>
  import { mapGetters, mapActions } from "vuex";
  // import Breadcumbs from '@/components/General/Breadcumbs'
  export default {
    name: "ViewCategories",
    components: {
      // Breadcumbs
    },
    props: {
      grade_subject_id: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        classroom_id:null,
        isLoading: true,
        is_locked: {},
        current_tab_index: 0,
        current_color: "#D839A7",
        color_mapping: {
          "#D839A7": {
            gradient_start: "#F4F4F4",
            gradient_end: "#FFC8EE",
          },
          "#BF57D5": {
            gradient_start: "#F4F4F4",
            gradient_end: "#DBB0FF",
          },
          "#4E95FF": {
            gradient_start: "#F4F4F4",
            gradient_end: "#D0F0FF",
          },
          "#00D7F4": {
            gradient_start: "#F4F4F4",
            gradient_end: "#D5FAFF",
          },
        },
      };
    },
    methods: {
      ...mapActions(["loadKids", "loadCategories", "loadGradeSubjectDetails", "lockUnlockCategory"]),
      goToSkills(category, parent = null) {
        if (category.is_not_allowed || (parent && parent.is_not_allowed)) return;
        this.$router.push({
          name: "kiddetail_category_skills",
          params: {
            kid_id: "6049c7ebe2f97e0013da87ff",
            grade_subject_id: this.grade_subject_id,
            category_id: category._id,
          },
        });
      },
      goToSkillsOrSubcategories(category, parent = null) {
        if (category.is_locked || category.is_not_allowed || (parent && parent.is_not_allowed)) return;
        if (category.children && category.children.length) {
          this.$router.push({
            name: "kiddetail_category_subcategories",
            params: {
              kid_id: "6049c7ebe2f97e0013da87ff",
              grade_subject_id: this.grade_subject_id,
              category_id: category._id,
            },
            query:{
              classroom_id: this.classroom_id
            }
          });
        } else {
          this.goToSkills(category);
        }
      },
      maxUpscoreOfSkill(responses) {
        if (responses && responses.length) {
          return Math.max(...responses.map((response) => response.upscore));
        } else {
          return null;
        }
      },
      currentCategoryChildren(children) {
        if (!children || !children.length) return [];
        return children;
      },
      indexToLetter(letterIndex) {
        return String.fromCharCode(letterIndex + "a".charCodeAt(0));
      },
      handleLockUnlock(id){
        this.lockUnlockCategory({
          token: this.getTeacherToken,
          data:{
            classroom: this.classroom_id,
            category: id,
            is_locked: this.is_locked[id]
          }
        })
      }
    },
    watch:{
      fetchCategories(new_val){
        if(new_val.length){
          for(let c of new_val){
            this.is_locked[c._id] = c.is_locked
          }
        }
      }
    },
    computed: {
      ...mapGetters([
        "getUserType",
        "getTeacherToken",
        "fetchCategories",
        "fetchKids",
        "fetchCurrentGradeSubject",
        "fetchColors",
      ]),
      themeColor() {
        let color = "#000";
        if (this.fetchCurrentGradeSubject) {
          color = this.fetchCurrentGradeSubject.grade.theme_color;
        }
        return color;
      },
      categoriesData() {
        let categories = [];
        const categories_length = this.fetchCategories.length;
        if (categories_length) {
          let mid_way = parseInt(Math.ceil(categories_length / 2));
          categories[0] = this.fetchCategories.slice(0, mid_way);
          categories[1] = this.fetchCategories.slice(mid_way, categories_length);
        }
  
        return categories;
      },
    },
    created() {
      this.isLoading = true;
      let urlParams = new URLSearchParams(window.location.search);
      this.classroom_id =urlParams.get('classroom_id');
      this.loadCategories({
        token: this.getTeacherToken,
        filter: {
          classroom: this.classroom_id,
          grade_subject: this.grade_subject_id,
          tree: true,
        },
      }).then(() => {
        this.isLoading = false;
      });
  
      // Theme color will also be set here
      this.loadGradeSubjectDetails({
        token: this.getTeacherToken,
        id: this.grade_subject_id,
      });
      

    },
  };
  </script>
  <style scoped>
  .flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .container {
    position: relative;
  }
  
  .title {
    font-size: 3vw;
    margin: 0 !important;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  
  .button {
    flex-direction: row;
    padding: 1vw 1.25vw;
    width: 100%;
    background: #8919e7;
    border-radius: 1vw;
    color: #fff;
    gap: 1vw;
    cursor: pointer;
    position: relative;
    text-transform: capitalize;
  }
  .button.outline {
    border: 0.063rem solid #8919e7;
    background: #fff;
    color: #000;
  }
  .link {
    cursor: pointer;
  }
  
  .main {
    align-items: center;
    margin: 0vw 0vw;
    position: relative;
    gap: 2.4vw;
  }
  /* responsive page*/
  
  /* tablet */
  @media screen and (max-width: 1023px) {
    .title {
      font-size: 3.5vw !important;
    }
  }
  
  /* Mobiles */
  @media screen and (max-width: 767px) {
    .title {
      font-size: 4vw !important;
    }
  }
  
  @media screen and (max-width: 467px) {
    .title {
      font-size: 5vw !important;
    }
  }
  .icon {
    position: absolute;
    height: 150px;
    max-width: 100%;
    width: auto;
    z-index: 5;
  }
  
  .img1 {
    top: -93px;
    left: 93px;
  }
  
  .img3 {
    top: -70px;
    right: 93px;
  }
  
  .img2 {
    bottom: 35px;
    left: 22px;
  }
  
  .img4 {
    bottom: 17%;
    right: 5px;
  }
  .img4 img {
    height: auto;
  }
  
  .img5 {
    top: -20%;
    left: 24%;
    z-index: 0;
  }
  .img5 img {
    height: auto;
  }
  
  .main {
    position: relative;
    padding: 4% 3.75% 0px;
    justify-content: center;
    align-items: center;
  }
  .main .card {
    box-shadow: none;
    background: linear-gradient(
      75.66deg,
      rgba(137, 25, 231, 0.1) 9.81%,
      rgba(49, 199, 255, 0.1) 95.1%
    );
    border-radius: 30px 30px 0px 0px;
    width: 100%;
  }
  
  .main .card .card-content {
    display: flex;
    background-image: url(/src/assets/images/cloud4.png);
    flex-direction: column;
    align-items: center;
    padding: 72px;
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: contain;
  }
  
  .main .card .card-content .columns {
    width: 100%;
    justify-content: center;
  }
  
  .main .card .card-content .columns .column {
    width: 430px;
  }
  
  .main .box {
    box-shadow: none;
    background: #ffffff;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    z-index: 10;
    position: relative;
  
  }
  .main .box .number,
  .main .box .progress {
    width: 40px;
    height: 40px;
    padding: 8px;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #fff;
  }
  .main .box .number {
    background: linear-gradient(46.55deg, #8919e7 5%, #31c7ff 97.57%);
    box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.22);
    border-radius: 9px;
  }
  .main .box .sub-title {
    display: flex;
    flex: 20;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #232323;
    cursor:pointer;
  }
  .main .box .progress {
    color: #31c7ff;
  }
  
  @media screen and (max-width: 768px) {
    .card-content {
      padding: 20px !important;
    }
    .columns {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .columns .column {
      width: 100%;
    }
    .icon {
      display: none;
    }
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }
  
  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .slider {
    background-color: #2196F3;
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }
  
  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }
  </style>